import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { LOGOUT } from "../Action/UserAction";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { MdSupportAgent } from "react-icons/md";
import { FaBookReader } from "react-icons/fa";

export default function MobileLeftSection({ SideOpener, Page }) {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const { Login_User } = useSelector((state) => state.USER_LOGIN_REDUCER);

  const handleLogout = (e) => {
    e.preventDefault();
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(async function (OneSignal) {
      console.log("OneSignal methods:", Object.keys(OneSignal));
      OneSignal.logout();
    });

    dispatch(LOGOUT());
  };

  useEffect(() => {
    if (!Login_User) {
      Navigate("/login");
    }
  });
  return (
    <>
      {/* <!-- Side Menu --> */}
      <div
        className={SideOpener ? "side-menu active" : "side-menu"}
        id="sideMenu"
      >
        <div className="side-menu-header">
          <div
            className="logo"
            onClick={(e) => {
              e.preventDefault();
              Navigate("/dashboard");
            }}
          >
            <img src="/testifyi_logo.svg" style={{ height: "60px" }} />
            {/* <div className="logo-icon">T</div>
            <div className="logo-text">
              <span className="logo-main">
                TEST<span className="logo-accent">E</span>FYI
              </span>
              <span className="logo-sub">LEARN • TEST • ACHIEVE</span>
            </div> */}
          </div>
        </div>

        <div className="profile-section">
          <div className="profile-avatar">
            <img
              src="/assets/image/user.svg"
              alt={
                Login_User?.First_Name
                  ? Login_User?.First_Name + " " + Login_User?.Last_Name
                  : ""
              }
            />
          </div>
          <div className="profile-info">
            <h3>
              {" "}
              {Login_User?.First_Name
                ? Login_User?.First_Name + " " + Login_User?.Last_Name
                : ""}
            </h3>
            <p>Continue Your Journey And Achieve Your Target</p>
            <button
              className="profile-btn"
              onClick={() => Navigate("/student/details-update/9")}
              data-page="attendance"
            >
              View Profile
            </button>
          </div>
        </div>

        <nav className="side-nav">
          <Link
            to="/dashboard"
            className={
              Page == "Dashboard"
                ? "nav-item lef-nav active"
                : "nav-item lef-nav"
            }
            data-page="dashboard"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 3.04333C12.0932 3.04333 12.1786 3.07243 12.2422 3.11853L21.1309 9.56677C21.1738 9.59796 21.2037 9.63506 21.2227 9.67126C21.2413 9.70705 21.25 9.74314 21.25 9.77771V20.6703C21.25 20.7287 21.2257 20.7965 21.1631 20.8549C21.0987 20.9149 21.0006 20.9564 20.8887 20.9564H3.11133C2.99938 20.9564 2.90127 20.9149 2.83691 20.8549C2.77433 20.7965 2.75 20.7287 2.75 20.6703V9.77771C2.75001 9.74314 2.75865 9.70705 2.77734 9.67126C2.79631 9.63506 2.82619 9.59796 2.86914 9.56677L11.7578 3.11853C11.8213 3.07243 11.9068 3.04333 12 3.04333ZM10.1387 20.3842H13.8613V12.6664H10.1387V20.3842Z"
                stroke="black"
                stroke-width="1.5"
              />
            </svg>

            <span>Home</span>
          </Link>

          <Link
            to="/course-material"
            className={
              Page == "Material"
                ? "nav-item lef-nav active"
                : "nav-item lef-nav"
            }
            data-page="materials"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.3701 8.87988H17.6201"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.37988 8.87988L7.12988 9.62988L9.37988 7.37988"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.3701 15.8799H17.6201"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.37988 15.8799L7.12988 16.6299L9.37988 14.3799"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <span>Materials</span>
          </Link>

          <Link
            to="/Recorded-classes"
            className={
              Page == "RecordClass"
                ? "nav-item lef-nav active"
                : "nav-item lef-nav"
            }
            data-page="Record"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.9116 7.70535C22.2604 7.43889 21.515 7.58878 21.0094 8.07173L18.6617 10.3532V10.0618C18.6617 7.76362 16.7424 5.89844 14.3775 5.89844H4.28417C1.91931 5.89844 0 7.76362 0 10.0618V14.6582C0 16.9563 1.91931 18.8215 4.28417 18.8215H14.3863C16.7512 18.8215 18.6705 16.9563 18.6705 14.6582V14.3667L21.0182 16.6482C21.3524 16.973 21.7979 17.1478 22.2521 17.1478C22.4748 17.1478 22.7062 17.1062 22.9204 17.0146C23.5716 16.7481 24 16.1403 24 15.4492V9.26235C24 8.57122 23.5802 7.96339 22.9204 7.69693L22.9116 7.70535ZM16.9565 14.6582C16.9565 16.0321 15.7998 17.1562 14.386 17.1562H4.2839C2.87013 17.1562 1.71339 16.0321 1.71339 14.6582V10.0619C1.71339 8.68798 2.87013 7.56386 4.2839 7.56386H14.386C15.7998 7.56386 16.9565 8.68798 16.9565 10.0619V14.6582ZM22.2261 15.4742L19.0302 12.3684L22.2777 9.27091L22.2261 15.4742Z"
                fill={Page == "RecordClass" ? "white" : "black"}
              />
            </svg>

            <span>Recorded Class</span>
          </Link>
          <Link
            to="/purchases"
            className={
              Page == "Purchases"
                ? "nav-item lef-nav active"
                : "nav-item lef-nav"
            }
            data-page="purchases"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.4467 9.6783L14.18 13.0116C14.08 14.0316 14 14.8116 12.1934 14.8116H3.80668C2.00002 14.8116 1.92002 14.0316 1.82002 13.0116L1.55335 9.6783C1.50002 9.12497 1.67335 8.61164 1.98668 8.2183C1.99335 8.21164 1.99335 8.21164 2.00002 8.20497C2.36668 7.7583 2.92002 7.4783 3.54002 7.4783H12.46C13.08 7.4783 13.6267 7.7583 13.9867 8.19164C13.9934 8.1983 14 8.20497 14 8.21164C14.3267 8.60497 14.5067 9.1183 14.4467 9.6783Z"
                stroke="#202020"
                stroke-width="1.5"
                stroke-miterlimit="10"
              />
              <path
                d="M2.33334 7.76496V4.33162C2.33334 2.06496 2.90001 1.49829 5.16668 1.49829H6.01334C6.86001 1.49829 7.05334 1.75162 7.37334 2.17829L8.22001 3.31162C8.43334 3.59162 8.56001 3.76496 9.12668 3.76496H10.8267C13.0933 3.76496 13.66 4.33162 13.66 6.59829V7.79162"
                stroke="#202020"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.28668 11.4783H9.71335"
                stroke="#202020"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <span>Purchases</span>
          </Link>

          <Link
            to="/cart"
            className={
              Page == "Cart" ? "nav-item lef-nav active" : "nav-item lef-nav"
            }
            data-page="purchases"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 18 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.46938 2.00543C1.34438 2.00543 1.22501 2.05371 1.13688 2.13942C1.04876 2.22452 0.99938 2.34101 1.00001 2.46111C1.00063 2.71159 1.21063 2.91439 1.46939 2.91499H2.81065C3.19565 2.91499 3.52692 3.15822 3.63066 3.51493L3.76129 3.96337V3.96397V3.96518L5.7394 10.7649C5.89065 11.2852 6.28315 11.6932 6.77879 11.8924C6.66816 12.0928 6.60504 12.3215 6.60504 12.5623C6.60504 13.3536 7.28068 14.0048 8.10132 14.0048C8.92195 14.0048 9.59759 13.3542 9.59759 12.5623C9.59759 12.3734 9.55884 12.1923 9.48884 12.0263H11.2551C11.1851 12.1923 11.1457 12.3734 11.1457 12.5623C11.1457 13.3536 11.8239 14.0048 12.6451 14.0048C13.4658 14.0048 14.1414 13.3542 14.1414 12.5623C14.1414 12.3734 14.1026 12.1923 14.0326 12.0263H14.8264C15.0852 12.0251 15.2939 11.823 15.2952 11.5737C15.2945 11.3232 15.0852 11.121 14.8264 11.1198H7.46886C7.08387 11.1198 6.74886 10.8766 6.64511 10.5199L6.59761 10.3557H13.6489C14.5539 10.3557 15.3502 9.76602 15.587 8.92285L16.9833 3.96457V3.96518C17.022 3.82817 16.9927 3.68151 16.9033 3.56924C16.8139 3.45638 16.6758 3.3906 16.5283 3.3906H4.57131L4.53631 3.26988C4.31943 2.52449 3.61255 2.00482 2.81005 2.00482L1.46938 2.00543ZM4.83631 4.3007H15.9139L14.6801 8.68434C14.5533 9.13521 14.1345 9.44604 13.6489 9.44604H6.33245L4.83631 4.3007ZM8.10131 12.0263C8.41318 12.0263 8.65444 12.2617 8.65444 12.5622C8.65444 12.8628 8.41318 13.0958 8.10131 13.0958C7.78943 13.0958 7.54505 12.8628 7.54505 12.5622C7.54505 12.2617 7.78942 12.0263 8.10131 12.0263ZM12.6457 12.0263C12.9576 12.0263 13.1988 12.2617 13.1988 12.5622C13.1988 12.8628 12.9576 13.0958 12.6457 13.0958C12.3338 13.0958 12.0894 12.8628 12.0894 12.5622C12.0894 12.2617 12.3338 12.0263 12.6457 12.0263Z"
                fill="#202020"
                stroke="#202020"
                stroke-width="0.4"
              />
            </svg>

            <span>My Cart</span>
          </Link>
          <Link
            to="/student/support"
            className={
              Page == "Support" ? "nav-item lef-nav active" : "nav-item lef-nav"
            }
          >
            {/* <svg
              width="24"
              height="24"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 10.145C9.10457 10.145 10 9.24953 10 8.14496C10 7.04039 9.10457 6.14496 8 6.14496C6.89543 6.14496 6 7.04039 6 8.14496C6 9.24953 6.89543 10.145 8 10.145Z"
                stroke="#202020"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.33334 8.73162V7.55829C1.33334 6.86496 1.90001 6.29162 2.60001 6.29162C3.80668 6.29162 4.30001 5.43829 3.69334 4.39162C3.34668 3.79162 3.55334 3.01162 4.16001 2.66496L5.31334 2.00496C5.84001 1.69162 6.52001 1.87829 6.83334 2.40496L6.90668 2.53162C7.50668 3.57829 8.49334 3.57829 9.10001 2.53162L9.17334 2.40496C9.48668 1.87829 10.1667 1.69162 10.6933 2.00496L11.8467 2.66496C12.4533 3.01162 12.66 3.79162 12.3133 4.39162C11.7067 5.43829 12.2 6.29162 13.4067 6.29162C14.1 6.29162 14.6733 6.85829 14.6733 7.55829V8.73162C14.6733 9.42496 14.1067 9.99829 13.4067 9.99829C12.2 9.99829 11.7067 10.8516 12.3133 11.8983C12.66 12.505 12.4533 13.2783 11.8467 13.625L10.6933 14.285C10.1667 14.5983 9.48668 14.4116 9.17334 13.885L9.10001 13.7583C8.50001 12.7116 7.51334 12.7116 6.90668 13.7583L6.83334 13.885C6.52001 14.4116 5.84001 14.5983 5.31334 14.285L4.16001 13.625C3.55334 13.2783 3.34668 12.4983 3.69334 11.8983C4.30001 10.8516 3.80668 9.99829 2.60001 9.99829C1.90001 9.99829 1.33334 9.42496 1.33334 8.73162Z"
                stroke="#202020"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg> */}

            <span style={{ fontSize: 24 }}>
              <MdSupportAgent />
            </span>

            <span>Support</span>
          </Link>

          <Link
            to="/student/books"
            className={
              Page == "Books" ? "nav-item lef-nav active" : "nav-item lef-nav"
            }
          >
            {/* <svg
              width="24"
              height="24"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 10.145C9.10457 10.145 10 9.24953 10 8.14496C10 7.04039 9.10457 6.14496 8 6.14496C6.89543 6.14496 6 7.04039 6 8.14496C6 9.24953 6.89543 10.145 8 10.145Z"
                stroke="#202020"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.33334 8.73162V7.55829C1.33334 6.86496 1.90001 6.29162 2.60001 6.29162C3.80668 6.29162 4.30001 5.43829 3.69334 4.39162C3.34668 3.79162 3.55334 3.01162 4.16001 2.66496L5.31334 2.00496C5.84001 1.69162 6.52001 1.87829 6.83334 2.40496L6.90668 2.53162C7.50668 3.57829 8.49334 3.57829 9.10001 2.53162L9.17334 2.40496C9.48668 1.87829 10.1667 1.69162 10.6933 2.00496L11.8467 2.66496C12.4533 3.01162 12.66 3.79162 12.3133 4.39162C11.7067 5.43829 12.2 6.29162 13.4067 6.29162C14.1 6.29162 14.6733 6.85829 14.6733 7.55829V8.73162C14.6733 9.42496 14.1067 9.99829 13.4067 9.99829C12.2 9.99829 11.7067 10.8516 12.3133 11.8983C12.66 12.505 12.4533 13.2783 11.8467 13.625L10.6933 14.285C10.1667 14.5983 9.48668 14.4116 9.17334 13.885L9.10001 13.7583C8.50001 12.7116 7.51334 12.7116 6.90668 13.7583L6.83334 13.885C6.52001 14.4116 5.84001 14.5983 5.31334 14.285L4.16001 13.625C3.55334 13.2783 3.34668 12.4983 3.69334 11.8983C4.30001 10.8516 3.80668 9.99829 2.60001 9.99829C1.90001 9.99829 1.33334 9.42496 1.33334 8.73162Z"
                stroke="#202020"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg> */}

            <span style={{ fontSize: 20 }}>
              <FaBookReader />
            </span>

            <span>Books</span>
          </Link>
        </nav>

        <div className="logout-section">
          <a onClick={handleLogout} className="logout-btn">
            <svg
              className="nav-icon"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16,17 21,12 16,7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            <span>Logout</span>
          </a>
        </div>
      </div>
    </>
  );
}
